import { ILogger } from '@cian/logger';

import { IOffer } from '../offer';
import { IMakeRequest } from '../utils/request';

export type TAgentRating = 'negative' | 'positive' | 'neutral';

export const updateRating = (
  makeRequest: IMakeRequest,
  offer: IOffer,
  rating: TAgentRating,
  logger: ILogger,
): Promise<{ status: string }> => {
  if (!offer.user) {
    return Promise.reject(new Error('offer.user is null'));
  }

  const parameters = {
    action: 'vote',
    rid: offer.user.cianUserId,
    rating,
  };

  return makeRequest({
    assertStatusCodes: [200, 400, 404],
    apiType: 'legacy',
    microserviceName: 'monolith-python',
    pathApi: `/ajax/${offer.dealType}/${offer.offerType}/realtor_ratings`,
    parameters,
    headers: [['Content-Type', 'application/x-www-form-urlencoded']],
    bodyAsEncodeString: true,
    method: 'POST',
  })
    .then((response: { status: string }) => {
      return response;
    })
    .catch(error => {
      logger.error(error as Error, {
        ...parameters,
        domain: 'src/shared/api/agent.ts',
      });

      throw error;
    });
};
